<div
  id="standard-modal"
  role="dialog"
  aria-labelledby="standard-modalLabel"
  aria-hidden="true"
  [hidden]="step !== 0"
>
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <div class="d-flex flex-column alin-items-start">
          <h4 class="modal-title" id="standard-modalLabel">Ações de CRM</h4>
          <span class="h6"> Selecione qual CRM você gostaria de manusear </span>
        </div>
      </div>

      <div class="tab-content" id="tabComponentsContent">
        <div class="modal-body custon-scrollbar">
          <div class="row">
            <div class="col-12 col-sm-6 col-lg-4 col-xl-3 mt-3">
              <div
                class="card"
                style="cursor: pointer; height: 148px"
                (click)="openDialogCrm(1, attendance)"
              >
                <div class="card-body">
                  <div class="d-flex justify-content-center mb-3">
                    <div class="icon-wrapper icon-wrapper--official">
                      <img
                        [src]="'../../../assets/images/logopipedrive.svg'"
                        width="50"
                        height="50"
                      />
                    </div>
                  </div>
                  <div class="d-flex justify-content-center">
                    <h5 class="card-title">Pipedrive</h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
